/**
 * Produces a random integer given a min and max range.
 * Number produced is inclusive of both min and max values.
 *
 * @param {number} [minNum] Minimum.
 * @param {number} [maxNum] Maximum.
 * @returns {number} The random integer.
 */
const getRandomInt = (minNum = 0, maxNum = 9999) => {
  const min = Math.ceil(minNum);
  const max = Math.floor(maxNum);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export default getRandomInt;
